<template lang="">
  <div class="tender-actual__table">
    <div class="tender-actual__header grid__row">
      <h5 class="tender-actual__title">{{ componentTitle }}</h5>
      <div class="tender-actual__select" ref="selectWrapper">
        <button class="tender-actual__select-button" ref="selectButton">
          <span ref="selectText">Выбранная опция</span>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 7.5L10 12.5L15 7.5" stroke="#636E7D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <div
          class="tender-actual__select-wrapper"
          :class="{'is-active': listIsOpen }"
        >
            <ul class="tender-actual__select-list" ref="selectList">
                <li
                    v-for="option in listOptions"
                    :key="option.id"
                    @click="(e) => onSelectOption(option, e.target)"
                    >
                    {{option.title}}
                </li>
            </ul>
        </div>
      </div>
    </div>
    <div class="tender-actual__list tender-actual__list_header grid__row">
      <button
        v-for='tab in tabs'
        :key="tab.id"
        :class="{'is-active': tab.name === selectedTab }"
        @click="onChangeTab(tab)"
        class="button button_theme_flat tender-actual__month-item"
        >
        <span class="button__text"> {{ tab.title }} </span>
      </button>
    </div>
    <div class="tender-actual__list grid__row">
      <!-- Временно скрыто (display: none): блок Telegram-бота «Тендеры Главстрой СПб» из-за неработоспособности бота. Убрать style после восстановления. -->
      <div class="tender-actual__social" style="display: none;">
        <a class="tender-actual__qr" href="https://t.me/tender_glavstroy_bot" target="_blank">
          <p>
            Быть в курсе просто. <br>
            Подпишитесь <br>
            на Telegram бот <br>
            Тендеры <br>
            Главстрой СПб <br>
          </p>
          <img alt="Главстрой Санкт-Петербург - Telegram bot" src="data:image/png;base64,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" />
        </a>
      </div>
      <div class="swiper tender-actual__slider" ref="customSwiper">
          <div class="swiper-wrapper tender-actual__slider-wrapper">
            <div class="slider-tender__list swiper-slide" v-for="tab in tabs" :key="tab.id">
                  <div class="slider-tender__list-line slider-tender__list-line_desktop">
                      <div class="slider-tender__list-item slider-tender__list-item_heading">Название объектов строительства</div>
                      <div class="slider-tender__list-item slider-tender__list-item_heading">Вид работ</div>
                      <div class="slider-tender__list-item slider-tender__list-item_heading slider-tender__list-project">Плановый срок проведения тендера</div>
                  </div>
                  <div
                    class="slider-tender__list-line"
                    v-for="tender in tab.tenders"
                    v-show="tender.show"
                    :key="tender.id"
                  >
                      <div class="slider-tender__list-item slider-tender__list-object">
                          <span>Проект</span>
                          <p v-if="tender.project" class="slider-tender__list-item-title"> {{ tender.project }}</p>
                          <span>Название объектов строительства</span>
                          <p v-if="tender.title">{{ tender.title }}</p>
                      </div>
                      <div class="slider-tender__list-item slider-tender__list-type">
                          <span>Вид работ</span>
                          <p v-if="tender.workType">{{ tender.workType }}</p>
                          <div class="slider-tender__list-item-container">
                            <a v-if="tender.link"
                              :href="tender.link"
                              class="button button_theme_blue slider-tender__list-claim"
                              target="_blank"
                            >
                                <div class="button__text">Перейти к тендеру</div>
                            </a>
                            <!-- TODO  -->
                            <a v-if="tab.name === 'future' && !tender.link"
                              data-href="#zayavka-form"
                              class="button button_theme_white slider-tender__list-claim"
                              target="_blank"
                              ref="buttonsOpenPopup"
                            >
                                <div class="button__text">Подать предварительную заявку</div>
                            </a>
                            <!-- TODO  -->
                            <div
                              v-if="tender.contact && (tender.contact.FIO || tender.contact.phone || tender.contact.email)"
                              class="slider-tender__list-item-contact"
                              @click="onToggleContact"
                            >
                                <div class="slider-tender__list-item-contact-top">
                                    <p>Контакты</p>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="18" height="18" rx="9" fill="#0058A6"/>
                                        <path d="M8.25 11.5L10.75 9L8.25 6.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="slider-tender__list-item-contact-body">
                                    <p><strong>{{ tender.contact.FIO || '&nbsp' }}</strong></p>
                                    <p>{{ tender.contact.phone || '&nbsp'}}</p>
                                    <p>{{ tender.contact.email || '&nbsp'}}</p>
                                </div>
                            </div>
                          </div>
                      </div>
                      <div class="slider-tender__list-item slider-tender__list-project">
                          <div>
                            <span>Плановый срок</span>
                            <p v-if="tender.deadline" class="slider-tender__list-item-planned-date">{{ tender.deadline }}</p>
                          </div>
                          <div v-if="tender.deadline_for_accepting" class="slider-tender__list-item-accepting-date">
                            <span v-if="tender.status === 'актуальный'">Прием заявок </span>
                            <strong v-if="tender.status === 'актуальный'">Прием заявок до: </strong>
                            <p v-if="tender.status === 'актуальный'">
                              {{ tender.deadline_for_accepting }}
                            </p>
                            <p v-else>
                              {{ tender.planned_date }}
                            </p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper, {EffectFade, HashNavigation} from 'swiper';
import {initCallbackPopup} from '../../common/scripts/common';

export default {
  name: 'tender-component',
  props: ['worktypes', 'tenders', 'tableTitle'],
  data() {
    return {
      slider: null,
      selectedTab: 'active',
      listIsOpen: false,
      isInitialized: false,
      tabs: [
        {
          id: '1',
          title: 'Текущие',
          name: 'active',
          numSlide: 1,
          tenders: [],
          options: [],
        },
        {
          id: '2',
          title: 'Предстоящие',
          name: 'future',
          numSlide: 2,
          tenders: [],
          options: [],
        },
      ],
      filteredTenders: {
        active: {
          tenders: [],
          options: []
        },
        future: {
          tenders: [],
          options: []
        },
      }
    }
  },
  computed: {
    componentTitle: function() {
      return this.tableTitle || 'Тендеры по видам работ';
    },
    listOptions: function() {
      return this.getCurrentTab().options;
    }
  },
  methods: {
    initSlider() {
      const tenderSlider = this.$refs.customSwiper;

      if (tenderSlider) {
        this.slider = new Swiper(tenderSlider,
          {
            modules          : [EffectFade, HashNavigation],
            autoHeight       : true,
            init             : false,
            loop             : false,
            speed            : 1000,
            observer         : true,
            observeParents   : true,
            spaceBetween     : 0,
            slidesPerView    : 1,
            slidesOffsetAfter: 0,
            allowTouchMove   : false,
            effect           : 'fade',
            fadeEffect       : {
                crossFade: true
            }
          })

        this.slider.init();

        this.tabs.forEach((tab) => {
          if (tab.name === this.selectedTab) {
            this.slider.slideTo(tab.numSlide - 1)
          }
        });
      }
    },
    filterTendersAndOptions() {
      if (this.tenders) {
        this.tenders.forEach((tender) => {
          const item = {
            ...tender,
            contact: tender.contact || {},
            show: true,
          }

          switch (tender?.status) {
            case 'актуальный':  this.filteredTenders.active.tenders.push(item);
              break;
            case 'предстоящий': this.filteredTenders.future.tenders.push(item);
              break;
            default:
              break;
          }
        })
      }

      if (this.worktypes) {
        // Все категории
        this.filteredTenders.active.options[0] = {
          id: Date.now(),
          title: 'Все категории',
          tenders: ['all'],
        };

        this.filteredTenders.future.options[0] = {
          id: Date.now(),
          title: 'Все категории',
          tenders: ['all'],
        }
        // \\Все категории

        this.worktypes.forEach((type) => {
          const item = {
            id: type.id,
            title: type.title,
          }

          if (type?.active?.length) {
            this.filteredTenders.active.options.push({
              ...item,
              tenders: type.active
            });
          }

          if (type?.future?.length) {
            this.filteredTenders.future.options.push({
              ...item,
              tenders: type.future
            });
          }
        })
      }
    },
    setTendersTabs() {
      this.tabs.forEach((tab) => {
        switch(tab.name) {
          case 'active': tab.tenders = this.filteredTenders.active.tenders;
            break;
          case 'future': tab.tenders = this.filteredTenders.future.tenders;
            break;
          default:
            tab.tenders = [];
            break;
        }
      });
    },
    setOptionsTabs() {
      this.tabs.forEach((tab) => {
        switch(tab.name) {
          case 'active': tab.options = this.filteredTenders.active.options;
            break;
          case 'future': tab.options = this.filteredTenders.future.options;
            break;
          default:
            tab.options = [];
            break;
        }
      })
    },
    setListeners() {
      this.$refs.selectButton.addEventListener('click', () => this.onToggleList());
      document.addEventListener('click', (e) => this.onClickOutside(e.target));
    },
    getCurrentTab() {
      return this.tabs.find((tab) => {
        if (tab.name === this.selectedTab) return tab
      })
    },
    selectFirstFilter() {
      const firstOption = this.getCurrentTab().options[0];
      const firstElement = this.$refs.selectList.childNodes[0];

      this.onSelectOption(firstOption, firstElement);
    },
    clearFilter() {
      const currentTab = this.getCurrentTab();

      currentTab.tenders.forEach((tender) => tender.show = true);

      this.$refs.selectList.childNodes.forEach((li) => {
        li.classList.remove('is-active')
      })
    },
    onChangeTab(tab) {
      if (tab) {
        if (tab.name === this.selectedTab) return;
        this.slider.slideTo(tab.numSlide - 1);
        this.selectedTab = tab.name;
        this.$nextTick(() => {
          this.selectFirstFilter();
          this.scrollToTable();
        })
      }
    },
    onSelectOption(option, element) {
      const currentTab = this.getCurrentTab();
      const isAllSelected = option.tenders[0] === 'all';

      this.clearFilter();
      element.classList.add('is-active');

      if (!isAllSelected) {
        const ids = option.tenders;
        currentTab.tenders.forEach((tender) => {
          tender.show = ids.includes(tender.id);
        });
      }

      this.$refs.selectText.textContent = option.title;
      this.closeList();
      this.scrollToTable();
    },
    onToggleContact(e) {
      e.currentTarget.classList.toggle('active');
    },
    onClickOutside(element) {
      const classesList = '.' + (this.$refs.selectWrapper.classList.value).split(' ').join('.');
      !element.closest(classesList) ? this.closeList() : null;
    },
    onToggleList() {
      this.listIsOpen = !this.listIsOpen
    },
    closeList() {
      this.listIsOpen = false;
    },
    scrollToTable() {
    if (!this.isInitialized) return;
      setTimeout(() => this.slider.updateAutoHeight());
      setTimeout(() => {
        this.$el.parentNode.scrollIntoView({
            behavior: "smooth",
            block: 'start',
          });
      }, 150)
    },
  },
  mounted() {
    this.initSlider();
    this.filterTendersAndOptions(); // фильтруем тендеры
    this.setTendersTabs();
    this.setOptionsTabs();
    this.setListeners();
    this.$nextTick(() => {
      this.selectFirstFilter();

      initCallbackPopup(this.$refs.buttonsOpenPopup, 'popup_theme_tenders');
      this.isInitialized = true;
    })
    // const tenderMonths = Array.from(document.querySelectorAll('.j-tender__month'));
    // const tenderMonthActive = document.querySelector('.j-tender__month.is-active');
    // const tenderSlider = document.querySelector('.j-tender-slider');
    const tenderMoreBtns = Array.from(document.querySelectorAll('.j-tender__more'));
    // const tenderContacts = Array.from(document.querySelectorAll('.j-tender__contact'));
    const tenderDropdown = document.querySelector('.j-tendet__droprodown');
  }
}
</script>
<style lang="scss">

</style>
